export default __webpack_public_path__ + "static/media/ic_sign_out_16.5544332c.svg";